import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import config from "../../../../config";
import InfiniteScroll from "react-infinite-scroll-component";
import PaginationLoader from "component/PaginationLoader";
import {
  ClientMembershipListViewApi,
  ClientMembershipUsageApi,
  CloseClientMembershipUsage,
  OpenClientMembershipUsage,
} from "store/slices/clientmembershipSlice";
import ApiStatus from "component/ApiStatus";
import PackageBalanceCard from "./PackageBalanceCard";
import PackageBalanceDetail from "./PackageBalanceDetail";
import { normalizePackageBalance, normalizePackageUsagePage } from "./packageBalanceContract";

const Membership = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const apiStatus = useSelector((state) => state.clientmembership.isApiStatus);
  const membershipViews = useSelector((state) => state.clientmembership.isListView);
  const membershipListError = useSelector((state) => state.clientmembership.isMembershipListViewError);
  const selectedPackage = useSelector((state) => state.clientmembership.isSelectedPackage);
  const usageView = useSelector((state) => state.clientmembership.isUsageView);
  const usageError = useSelector((state) => state.clientmembership.isMembershipUsageError);
  const detail = useSelector((state) => state.client.isDetailData) || {};
  const listClientId = useSelector((state) => state.clientmembership.listClientId);
  const owned = Number(detail.id) > 0 && listClientId === Number(detail.id);
  const rows = owned && Array.isArray(membershipViews?.data) ? membershipViews.data : [];
  const packages = rows.map(normalizePackageBalance);
  const normalizedUsage = normalizePackageUsagePage(usageView);

  const fetchNextPackagePage = () => {
    if (owned && membershipViews?.next_page_url) {
      dispatch(ClientMembershipListViewApi({ client_id: detail.id, next_page_url: membershipViews.next_page_url }));
    }
  };

  const openUsage = (packageBalance) => {
    dispatch(OpenClientMembershipUsage(packageBalance));
    dispatch(ClientMembershipUsageApi({
      client_id: detail.id,
      package_instance_id: packageBalance.packageInstanceId,
      page: 1,
      limit: 10,
    }));
  };

  const loadMoreUsage = (nextPageUrl) => {
    if (!selectedPackage?.packageInstanceId) return;
    dispatch(ClientMembershipUsageApi({
      client_id: detail.id,
      package_instance_id: selectedPackage.packageInstanceId,
      next_page_url: nextPageUrl,
    }));
  };

  return (
    <>
      <div className="drawer-header">
        <h2 className="mb-4 pe-md-5 mb-lg-5">{t("Package")}</h2>
      </div>
      <div className="content-wrp" id="membershiplist">
        {owned && membershipListError && <div className="alert alert-danger" role="alert">{membershipListError}</div>}
        {packages.length > 0 ? (
          <InfiniteScroll
            className="row gx-0"
            dataLength={packages.length}
            next={fetchNextPackagePage}
            scrollableTarget="membershiplist"
            hasMore={Boolean(membershipViews?.next_page_url)}
            loader={<PaginationLoader />}
          >
            {packages.map((packageBalance) => (
              <PackageBalanceCard
                key={packageBalance.packageInstanceId || packageBalance.id}
                packageBalance={packageBalance}
                onViewUsage={openUsage}
              />
            ))}
          </InfiniteScroll>
        ) : apiStatus?.ClientMembershipListViewApi === "loading" ? (
          <ApiStatus actionType="clientmembershipview" />
        ) : (
          <div className="complete-box text-center d-flex flex-column justify-content-center mt-xl-4">
            <div className="complete-box-wrp text-center">
              <img src={config.imagepath + "nots.png"} alt="" className="mb-md-4 mb-3" />
              <h5 className="mb-2 fw-semibold">{t("There are no packages available.")}</h5>
            </div>
          </div>
        )}
      </div>
      {owned && selectedPackage && (
        <PackageBalanceDetail
          packageBalance={selectedPackage}
          usagePage={normalizedUsage}
          loading={apiStatus?.ClientMembershipUsageApi === "loading"}
          error={usageError}
          onClose={() => dispatch(CloseClientMembershipUsage())}
          onLoadMore={loadMoreUsage}
        />
      )}
    </>
  );
};

export default Membership;
